(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipsy-cart"] && !Shopify.designMode) return;
  try {
    
  // ── Le passage au paiement ────────────────────────────────────────────
  // C'est l'attente la plus longue et la plus chère du tunnel, et le bouton
  // n'en disait rien : il restait au repos et re-cliquable pendant toute la
  // redirection. Un double clic sur un formulaire de panier crée un second
  // aller vers le paiement — au mieux une confusion, au pire une commande
  // en double.
  //
  // On NE met PAS `disabled` : le bouton porte `name="checkout"`, et un
  // champ désactivé n'est pas envoyé — Shopify perdrait l'action demandée.
  // On neutralise donc les clics suivants par `pointer-events` et on marque
  // l'attente avec `aria-busy`, que les lecteurs d'écran annoncent.
  (() => {
    const form = document.getElementById('cart-form');
    if (!form) return;

    let parti = false;
    form.addEventListener('submit', () => {
      if (parti) return;
      parti = true;
      const btns = form.ownerDocument.querySelectorAll(
        '[form="cart-form"][name="checkout"], #cart-form [name="checkout"]'
      );
      btns.forEach((b) => {
        b.setAttribute('aria-busy', 'true');
        b.classList.add('tpc__checkout--busy');
      });
      // Filet de sécurité : si le navigateur revient en arrière sans
      // recharger (cache de retour), le bouton doit redevenir cliquable.
      setTimeout(() => {
        parti = false;
        btns.forEach((b) => {
          b.removeAttribute('aria-busy');
          b.classList.remove('tpc__checkout--busy');
        });
      }, 12000);
    });

    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      parti = false;
      document.querySelectorAll('.tpc__checkout--busy').forEach((b) => {
        b.removeAttribute('aria-busy');
        b.classList.remove('tpc__checkout--busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipsy-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tipsy-lookbook-slider')) {
    customElements.define('tipsy-lookbook-slider', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('enabled') || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.tlb__grid');
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.visible = false;
        this.updateButton();
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
          this.paused = true;
          this.updateButton();
          this.move(Number(button.dataset.step));
        }, { signal }));
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateButton();
        }, { signal });
        this.track.addEventListener('pointerdown', () => {
          this.paused = true;
          this.updateButton();
        }, { signal, passive: true });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.paused = true; this.updateButton(); }
        }, { signal });
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: 0.2 });
        this.observer.observe(this.track);
        this.timer = setInterval(() => {
          if (this.paused || !this.visible || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
          this.move(1);
        }, 4000);
      }
      updateButton() {
        this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
      }
      move(direction) {
        const step = this.track.firstElementChild.getBoundingClientRect().width;
        const max = this.track.scrollWidth - this.track.clientWidth;
        let next = this.track.scrollLeft + direction * step;
        if (direction > 0 && this.track.scrollLeft >= max - 2) next = 0;
        if (direction < 0 && this.track.scrollLeft <= 2) next = max;
        this.track.scrollTo({ left: Math.max(0, Math.min(max, next)), behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipsy-pdp-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tipsy-pdp-gallery')) {
    class TipsyPdpGallery extends HTMLElement {
      connectedCallback() {
        this.strip = this.querySelector('[data-tpg-strip]');
        this.up = this.querySelector('[data-tpg-up]');
        this.down = this.querySelector('[data-tpg-down]');

        // Les flèches de la grande image sont des <label> : au clic elles
        // basculent déjà le radio sans JS, mais un label ne se valide pas à
        // Entrée. On les promeut en boutons, et on lève l'aria-hidden qui les
        // tenait à l'écart tant qu'elles n'étaient pas activables au clavier.
        this.arrows = Array.from(this.querySelectorAll('[data-tpg-arrow]'));
        this.handleArrowKey = (event) => this.activateArrow(event);
        for (const arrow of this.arrows) {
          arrow.removeAttribute('aria-hidden');
          arrow.setAttribute('role', 'button');
          arrow.setAttribute('tabindex', '0');
          // Libellés traduits, posés par Liquid en attributs : ce bloc est du
          // JS statique, le filtre de traduction n'y passe pas.
          arrow.setAttribute(
            'aria-label',
            arrow.dataset.tpgArrow === 'prev' ? this.dataset.tpgLabelPrev : this.dataset.tpgLabelNext
          );
          arrow.addEventListener('keydown', this.handleArrowKey);
        }

        this.handleChange = (event) => this.revealActiveThumb(event);
        this.addEventListener('change', this.handleChange);

        // Changement de variante sans rechargement : `variant-picker.js` ne
        // morphe que la section qui porte le sélecteur, jamais celle-ci. On
        // écoute donc l'événement standard, qui remonte jusqu'à `document`.
        // Son nom est écrit en clair faute de pouvoir importer
        // `StandardEvents` depuis un bloc de script de section.
        try {
          this.variantMedia = JSON.parse(
            this.querySelector('[data-tpg-variant-media]')?.textContent || '{}'
          );
        } catch {
          this.variantMedia = {};
        }
        this.handleProductSelect = (event) => this.syncVariantMedia(event);
        document.addEventListener('shopify:product:select', this.handleProductSelect);

        if (this.strip) {
          this.handleScroll = () => this.sync();
          this.strip.addEventListener('scroll', this.handleScroll, { passive: true });
          this.up?.addEventListener('click', () => this.nudge(-1));
          this.down?.addEventListener('click', () => this.nudge(1));

          // Le nombre de vignettes tenant à l'écran change au point de
          // rupture : on remesure plutôt que de supposer.
          this.resizeObserver = new ResizeObserver(this.handleScroll);
          this.resizeObserver.observe(this.strip);
          this.sync();
        }
      }

      disconnectedCallback() {
        this.strip?.removeEventListener('scroll', this.handleScroll);
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:product:select', this.handleProductSelect);
        for (const arrow of this.arrows ?? []) {
          arrow.removeEventListener('keydown', this.handleArrowKey);
        }
      }

      // Les cartes produit et l'ajout rapide émettent le MÊME événement sur
      // `document` : on ne réagit qu'au produit de cette galerie.
      syncVariantMedia(event) {
        if (String(event.product?.id ?? '') !== String(this.dataset.tpgProduct ?? '')) return;

        // Chemin synchrone : le sélecteur passe l'id de variante dans la
        // charge de l'événement, l'image bascule sans attendre le réseau.
        if (this.checkMediaForVariant(event.detail?.variantId)) return;

        // Repli, quand l'id n'était pas sous la main : il arrive avec la
        // variante résolue, sous forme de GID — d'où le dernier segment.
        event.promise
          ?.then(({ variant }) =>
            this.checkMediaForVariant(String(variant?.id ?? '').split('/').pop())
          )
          .catch(() => {});
      }

      checkMediaForVariant(variantId) {
        const mediaId = variantId ? this.variantMedia?.[variantId] : undefined;
        if (!mediaId) return false;

        const input = this.querySelector(`[data-tpg-state][value="${mediaId}"]`);
        if (!input) return false;
        if (input.checked) return true;

        input.checked = true;
        // `checked` posé en script n'émet rien : on relaie pour que la bande
        // se recentre sur la vignette devenue active.
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      get reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      // La bande est verticale au-delà de 56rem, horizontale en dessous : on
      // lit l'axe réellement débordant plutôt que de refaire la requête média.
      get vertical() {
        return this.strip.scrollHeight - this.strip.clientHeight > 1;
      }

      activateArrow(event) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();

        const arrow = event.currentTarget;
        const target = document.getElementById(arrow.getAttribute('for'));
        if (!target) return;

        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));

        // La flèche qu'on vient d'actionner appartient à la diapositive qui
        // disparaît : sans ce report, le focus retomberait sur <body>.
        const slide = this.querySelector(`[data-tpg-slide="${target.dataset.tpgIndex}"]`);
        slide?.querySelector(`[data-tpg-arrow="${arrow.dataset.tpgArrow}"]`)?.focus();
      }

      revealActiveThumb(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-tpg-state')) return;

        input.closest('[data-tpg-thumb]')?.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: this.reducedMotion ? 'auto' : 'smooth',
        });
      }

      nudge(direction) {
        const button = direction < 0 ? this.up : this.down;
        if (button?.getAttribute('aria-disabled') === 'true') return;

        const vertical = this.vertical;
        const page = vertical ? this.strip.clientHeight : this.strip.clientWidth;
        const behavior = this.reducedMotion ? 'auto' : 'smooth';

        // Quatre cinquièmes d'écran : une vignette reste visible d'un volet à
        // l'autre, ce qui donne le repère de continuité.
        const amount = page * 0.8 * direction;
        this.strip.scrollBy(vertical ? { top: amount, behavior } : { left: amount, behavior });
      }

      sync() {
        if (!this.up && !this.down) return;

        const vertical = this.vertical;
        const overflow = vertical
          ? this.strip.scrollHeight - this.strip.clientHeight
          : this.strip.scrollWidth - this.strip.clientWidth;
        const position = Math.abs(vertical ? this.strip.scrollTop : this.strip.scrollLeft);

        this.up?.setAttribute('aria-disabled', position <= 1 ? 'true' : 'false');
        this.down?.setAttribute('aria-disabled', position >= overflow - 1 ? 'true' : 'false');
      }
    }

    customElements.define('tipsy-pdp-gallery', TipsyPdpGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipsy-pdp-info"] && !Shopify.designMode) return;
  try {
    
  // ── Taille : choix explicite exigé ─────────────────────────────────────
  // Décocher la radio casserait variant-picker.js (le thème le documente) :
  // la coche RESTE donc en place pour la mécanique — prix, galerie,
  // variantId — mais elle est neutralisée visuellement et l'achat est
  // verrouillé jusqu'à un geste du client. Deux barrières : le bouton est
  // désactivé, ET le submit est intercepté en phase de capture au cas où le
  // script du thème réactiverait le bouton en mettant à jour la variante.
  // Sans JavaScript, rien de tout ceci ne s'exécute : la taille S reste
  // cochée et le formulaire fonctionne comme avant.
  (() => {
    const buy = document.querySelector('.tpb');
    if (!buy) return;
    if (buy.dataset.selectedVariant) return;
    const sizeRadios = [...buy.querySelectorAll('.tpb__radio[data-size-option="true"]')];
    if (sizeRadios.length < 2) return; // une seule taille : rien à choisir

    const form = buy.querySelector('form[data-type="add-to-cart-form"]');
    const atc = buy.querySelector('.tpb__atc');
    const hint = buy.querySelector('[data-tpb-size-hint]');
    if (!form || !atc) return;

    let chosen = false;
    buy.classList.add('tpb--size-unchosen');
    // CRO 23/10/2026 : avant le choix, le bouton n'est plus grisé. Il dit
    // « Select a size » (pseudo-élément lu dans data-choose) et un clic
    // amène aux tailles. L'ajout reste bloqué par la garde ci-dessous.
    atc.dataset.choose = buy.dataset.chooseSize || '';
    const atcLabel = atc.getAttribute('aria-label');
    atc.setAttribute('aria-label', buy.dataset.chooseSize || '');

    // La barre collante reste visible AVANT le choix de taille (table ronde
    // du 28/09/2026) : elle dit alors « Select a size » et ramène au
    // sélecteur au lieu d'ajouter une taille S que personne n'a choisie.
    const sticky = document.querySelector('.sticky-add-to-cart__button');
    const stickyLabel = sticky?.getAttribute('aria-label');
    sticky?.setAttribute('aria-label', buy.dataset.chooseSize);

    const choose = () => {
      if (chosen) return;
      chosen = true;
      buy.classList.remove('tpb--size-unchosen');
      if (atcLabel) atc.setAttribute('aria-label', atcLabel);
      else atc.removeAttribute('aria-label');
      if (hint) hint.hidden = true;
      if (sticky && stickyLabel) sticky.setAttribute('aria-label', stickyLabel);
    };

    // `click` et non `change` : cliquer la taille déjà cochée (S) n'émet pas
    // de `change`, et c'est pourtant un choix parfaitement valable.
    sizeRadios.forEach((r) => {
      r.addEventListener('click', choose);
      const lb = r.closest('label');
      if (lb) lb.addEventListener('click', choose);
    });

    // Capture sur `window`, PAS sur le formulaire. Corrigé le 2026-09-27 :
    // Horizon écoute `submit` sur `document` en capture (component.js) et
    // lançait `/cart/add.js` AVANT que l'écouteur posé sur le formulaire ne
    // s'exécute — le `stopImmediatePropagation` arrivait trop tard et le
    // client recevait une taille S qu'il n'avait pas choisie. `window` est
    // le premier nœud de la phase de capture : on y passe avant Horizon.
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const toSizes = () => {
      const sz = buy.querySelector('.tpb__sizes');
      if (sz) {
        sz.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        sz.classList.remove('tpb__sizes--nudge');
        void sz.offsetWidth;
        sz.classList.add('tpb__sizes--nudge');
      }
      if (hint) {
        hint.hidden = false;
        hint.focus({ preventScroll: true });
      }
    };
    window.addEventListener(
      'submit',
      (e) => {
        if (chosen || e.target !== form) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        toSizes();
      },
      true
    );
    // Même barrière pour la barre collante, dont le bouton n'est pas un
    // submit : Horizon le traite par un `click` délégué sur `document`.
    // `window` en capture passe avant lui.
    window.addEventListener(
      'click',
      (e) => {
        if (chosen || !sticky || !sticky.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        toSizes();
      },
      true
    );
  })();

  // Guide des tailles : ouverture en modale. Depuis le 23/10/2026 le lien
  // vit DANS la légende « Size », à l'intérieur de <variant-picker>, que
  // variant-picker.js morphe à chaque changement de taille : écoute par
  // délégation sur `document`, jamais sur le nœud. Sans JavaScript, c'est un
  // vrai lien vers la page du guide.
  (() => {
    const dialog = document.querySelector('[data-tpb-guide-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    document.addEventListener('click', (e) => {
      const open = e.target instanceof Element ? e.target.closest('[data-tpb-guide-open]') : null;
      if (!open) return;
      e.preventDefault();
      dialog.showModal();
    });
    dialog.querySelector('[data-tpb-guide-close]')?.addEventListener('click', () => dialog.close());
    // clic sur le voile = fermeture
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
  })();

  // Duo hors euros (CRO 23/10/2026) : Shopify convertit la remise de
  // 4,80 € au taux de Shopify.currency.rate, arrondi au cent (mesuré :
  // 480 × 1,14468 = 549 cents US). On refait ce calcul pour afficher le
  // prix exact du duo et l'économie. Sans taux : la phrase sans chiffre reste.
  (() => {
    const el = document.querySelector('[data-tpb-pair]');
    if (!el || el.dataset.currency === 'EUR') return;
    const rate = Number(window.Shopify?.currency?.rate);
    const unit = Number(el.dataset.unit);
    const discEur = Number(el.dataset.discEur);
    const cur = window.Shopify?.currency?.active || el.dataset.currency;
    const tpl = el.dataset.template;
    const out = el.querySelector('[data-tpb-pair-text]');
    if (!rate || !unit || !discEur || !cur || !tpl || !out) return;
    const disc = Math.round(discEur * rate);
    const total = unit * 2 - disc;
    let fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: cur,
        currencyDisplay: 'narrowSymbol',
      });
    } catch (e) {
      return;
    }
    const money = (cents) => fmt.format(cents / 100).replace(/[.,]00(?=\D*$)/, '');
    out.textContent = tpl.replace('%P', money(total)).replace('%S', money(disc));
  })();

  // Barre collante visible dès l'arrivée sur mobile (CRO 23/10/2026).
  // sticky-add-to-cart.js ne la montre qu'une fois le bouton principal
  // DÉPASSÉ ; ici on la montre aussi tant qu'il est encore PLUS BAS que
  // l'écran, et on la cache quand il est visible (jamais deux boutons).
  // Même seuil que la feuille de style mobile de la barre : 749 px.
  (() => {
    const block = document.querySelector('.tpb .buy-buttons-block');
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!block || !bar || !('IntersectionObserver' in window)) return;
    const mobile = window.matchMedia('(max-width: 749px)');
    const io = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry || !mobile.matches) return;
      if (entry.isIntersecting) bar.dataset.stuck = 'false';
      else if (entry.boundingClientRect.top > 0) bar.dataset.stuck = 'true';
    });
    io.observe(block);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipsy-product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tipsy-product-rail')) {
    class TipsyProductRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        if (!this.track) return;

        this.nav = this.querySelector('[data-rail-nav]');
        this.prev = this.querySelector('[data-rail-prev]');
        this.next = this.querySelector('[data-rail-next]');

        this.handleScroll = () => this.sync();
        this.prev?.addEventListener('click', () => this.page(-1));
        this.next?.addEventListener('click', () => this.page(1));
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });

        // Le nombre de cartes visibles change aux points de rupture : on
        // remesure plutôt que de recalculer une largeur en dur.
        this.resizeObserver = new ResizeObserver(() => this.sync());
        this.resizeObserver.observe(this.track);

        this.sync();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.resizeObserver?.disconnect();
      }

      get step() {
        const first = this.track.firstElementChild;
        if (!first) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      page(direction) {
        const button = direction < 0 ? this.prev : this.next;
        if (button?.getAttribute('aria-disabled') === 'true') return;

        const rtl = getComputedStyle(this).direction === 'rtl';
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: this.step * direction * (rtl ? -1 : 1),
          behavior: reduced ? 'auto' : 'smooth',
        });
      }

      sync() {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        // Quatre produits qui tiennent tous à l'écran n'ont pas besoin de flèches.
        this.nav?.toggleAttribute('hidden', overflow <= 1);
        if (overflow <= 1) return;

        const position = Math.abs(this.track.scrollLeft);
        this.prev?.setAttribute('aria-disabled', position <= 1 ? 'true' : 'false');
        this.next?.setAttribute('aria-disabled', position >= overflow - 1 ? 'true' : 'false');
      }
    }

    customElements.define('tipsy-product-rail', TipsyProductRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipsy-shop-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tipsy-shop-grid')) {
    class TipsyShopGrid extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-shop-form]');
        if (!this.form) return;

        // Le drapeau masque le bouton « Apply » : il ne sert qu'au parcours
        // sans JS. Il est posé par le MÊME script qui renvoie le formulaire,
        // donc les deux ne peuvent pas se désynchroniser.
        this.form.dataset.js = 'true';

        this.onChange = () => this.submit();
        this.form.addEventListener('change', this.onChange);

        // Sur petit écran la colonne s'ouvrirait au-dessus de la grille et
        // repousserait les produits hors de l'écran : on la replie. Sans JS
        // elle reste ouverte — dépliée mais utilisable, jamais inaccessible.
        this.panel = this.querySelector('[data-filters]');
        this.desktop = window.matchMedia('(min-width: 64rem)');
        this.syncPanel = () => {
          if (this.panel) this.panel.open = this.desktop.matches;
        };
        this.desktop.addEventListener('change', this.syncPanel);
        this.syncPanel();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('change', this.onChange);
        this.desktop?.removeEventListener('change', this.syncPanel);
      }

      submit() {
        // Un champ de prix vide partirait quand même en `…price.gte=` et
        // salirait l'URL : on le neutralise juste avant l'envoi.
        this.form.querySelectorAll('input[type="text"]').forEach((input) => {
          input.disabled = input.value.trim() === '';
        });

        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      }
    }

    customElements.define('tipsy-shop-grid', TipsyShopGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
